module.exports = __webpack_public_path__ + "static/media/pengisian_nilai_ekskul.7357ee52.png";